export default "__VITE_ASSET__1_SKe6bu__"